import React, { useEffect, useState } from "react";
import ComboBox from "../../Components/ComboBox";
function CustomerCombo({ options, setFieldValue, withoutForm }) {
  const [value, setValue] = useState("00000000-0000-0000-0000-000000000000");
  const [inputValue, setInputValue] = useState("");
  const optionConvert = options?.map((item) => ({
    label: item.key,
    value: item.value,
  }));
  useEffect(() => {
    if (withoutForm) {
      setFieldValue(value);
    } else {
      setFieldValue("customerId", value);
    }
  }, [value]);

  return (
    <ComboBox
      lable={"نام مشتریان"}
      inputValue={inputValue}
      setInputValue={setInputValue}
      value={value}
      setValue={setValue}
      options={optionConvert}
    />
  );
}

export default CustomerCombo;
